var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxisY(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.918 4.18416V6.16016H2.878V4.20016L0.678 0.560156H1.79L3.43 3.28816L5.086 0.560156H6.11L3.918 4.18416Z",
    fill: "#ACAFB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxisY);
export default __webpack_public_path__ + "static/media/axis_y.d3f086bd59d4f2e0e4c96ae820d21390.svg";
export { ForwardRef as ReactComponent };